import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-styled-flexboxgrid';
import { useSwipeable } from 'react-swipeable';

import Box from '../../Global/Atomics/Box'
import { Button } from '../../Global/Atomics/Button';
import { Map } from '../../Global/Widgets/Map/Map';
import { Modal } from '../../Global/Atomics/Modal'
import { Paragraph } from '../../Global/Atomics/Paragraph';

import { useTranslationContext } from '../../../contexts/TranslationContext';
import lockScrollbar from '../../../utils/helpers/lockScrollbar';

type TProps = {
    showModal: boolean;
    setShowModal: (value: boolean | ((prevVar: boolean) => boolean)) => void;
}

const MapModal = ({ showModal, setShowModal }: TProps) => {
    const [section, setSection] = useState<string | null>(null);
    const [position, setPosition] = useState<{ lat: number, lng: number } | null>(null);
    const navigate = useNavigate();
    const { resources } = useTranslationContext();

    let configs = {
        delta: 30,
        onSwipedDown: () => setShowModal(false),
    }

    const handleNavigation = () => {
        navigate('/report', { state: { section, position } });
        lockScrollbar(false);
    }

    return (
        <Modal dynamic show={showModal} onClose={() => setShowModal(false)} >
            <Box my="lg" mx="md" px="xs">
                <Row center="xs">
                    <Col xs={12} {...useSwipeable(configs)}>
                        {/* Problems? */}
                        <Box mb="md">
                            <Paragraph typography="text-m-semibold" customColor="black-1" mb="xs">{resources.home.title}</Paragraph>
                            <Paragraph typography="text-xs-medium" customColor="black-1">{resources.home.paragraph}</Paragraph>
                        </Box>
                    </Col>

                    {/* Map */}
                    <Col xs={12}>
                        <Box height="50vh" bg="blue-1" boxShadow="level2" borderRadius="lg" mb="lg" zIndex={100}>
                            <Map
                                displaySections
                                getLatLng={(val) => setPosition(val)}
                                getSection={(val) => setSection(val)}
                            />
                        </Box>
                    </Col>

                    {/* CTAs */}
                    <Col xs={9} md={6} {...useSwipeable(configs)}>
                        <Box mb="lg">
                            <Button size="s" variant="primary-black" width="100%" onClick={handleNavigation} disabled={!position || !section}>
                                {resources.label.map.continueWithLocation}
                            </Button>
                        </Box>
                        <Box mb="lg">
                            <Button id="btn-my-location" size="s" variant="secondary-black" width="100%">{resources.label.map.useMyLocation}</Button>
                        </Box>
                    </Col>
                </Row>
            </Box>
        </Modal>
    )
}

export default MapModal